import React, { useState, useEffect } from 'react';
import logo from '../../../images/logo.svg';
import ipaLogo from '../../../images/IPA Logo (10).png';
import BurgerMenu from './BurgerMenu';
import color from '../../styling/theme';
import styled from 'styled-components';
import theme from '../../styling/theme';

import {
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';

interface NavigationProps {
  enquiryHeading?: string;
  enquiryText?: string;
  menuIsOpen: boolean;
  toggleMenu: any;
}

const links = [
  {
    title: 'R&D Tax Credit',
    slug: '/tax-credit',
  },
  {
    title: 'Claims Process',
    slug: '/claims-process',
  },
  {
    title: 'Industry Sector',
    slug: '/industry-sector',
  },
  {
    title: 'Intellectual Property',
    slug: '/intellectual-property',
  },
  {
    title: 'Sponsorships',
    slug: '/sponsorships',
  },
  {
    title: 'About us',
    slug: '/about-us',
  },
  {
    title: 'Blog',
    slug: 'https://blog.rda.co.uk',
  },
  {
    title: 'Contact',
    slug: '/contact-us',
  },
];

const MobileNavigation = ({ menuIsOpen, toggleMenu }: NavigationProps) => {
  const [scrollValue, setScrollValue] = useState(0);

  const basePath = process.env.BASE === '/' || !process.env.BASE ? '' : process.env.BASE;

  const handleOpenBurgerMenu = () => {
    setScrollValue(window.pageYOffset);
    toggleMenu(!menuIsOpen);
  };

  useEffect(() => {
    const getWindowScroll = () => {
      const container = document.getElementById('mobile-nav-container');
      const nav = document.getElementById('mobile-container-nav');

      if (container && nav) {
        if (window.pageYOffset > 350) {
          container.style.marginBottom = '73px';
          nav.style.cssText =
            'position: fixed; top: 0; left: 0; right: 0; z-index: 999;';
        } else if (window.pageYOffset <= 350) {
          nav.style.position = 'relative';
          container.style.marginBottom = '0px';
        }
      }
    };

    window.addEventListener('scroll', getWindowScroll);

    return () => {
      window.removeEventListener('scroll', getWindowScroll);
    };
  }, []);

  useEffect(() => {
    let last: number = 0;

    const animateNavigation = () => {
      const nav: HTMLElement | null = document.getElementById(
        'mobile-container-nav'
      );
      const container: HTMLElement | null = document.getElementById(
        'mobile-nav-container'
      );
      const topNav: HTMLElement | null = document.getElementById('top-nav');
      const menu: HTMLElement | null = document.getElementById('menuBtn');

      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (nav && container && topNav && menu) {
          const currentScroll: number =
            document.documentElement.scrollTop || document.body.scrollTop;

          if (
            currentScroll >= 0 &&
            currentScroll <= 150 &&
            window.innerWidth <= 1023
          ) {
            last = currentScroll;
            container.style.display = 'block';

            nav.style.display = 'none';
            topNav.style.visibility = 'initial';
          } else if (
            currentScroll > 0 &&
            last <= currentScroll &&
            window.pageYOffset > 0 &&
            !menuIsOpen
          ) {
            last = currentScroll;
            nav.style.display = 'none';
            topNav.style.visibility = 'initial';
          } else if (currentScroll > 0 && window.innerWidth <= 1023) {
            nav.style.display = 'block';
            nav.style.borderBottom = '1px solid #ddd';
            nav.style.boxShadow = '0 1px 10px rgba(0, 0, 0, 0.1)';
            topNav.style.visibility = 'hidden';
            last = currentScroll;
          }
        }
      }
    };

    window.addEventListener('scroll', animateNavigation);

    return () => {
      window.removeEventListener('scroll', animateNavigation);
    };
  }, [menuIsOpen]);

  useEffect(() => {
    const resetBody = () => {
      const body: HTMLElement | null = document.querySelector('body');

      if (window && body) {
        if (window.innerWidth > 1023) {
          enableBodyScroll(body);
          clearAllBodyScrollLocks();
          toggleMenu(false);
        }
      }
    };

    window.addEventListener('resize', resetBody);

    return () => {
      window.removeEventListener('resize', resetBody);
    };
  }, [toggleMenu]);

  return (
    <Outer id="mobile-nav-container">
      <BurgerMenu
        closeMenu={() => {
          toggleMenu(!menuIsOpen);
        }}
        menuIsOpen={menuIsOpen}
        links={links}
        scrollValue={scrollValue}
        ipaLogo={ipaLogo}
        ipaLogoUrl="https://ip-a.co.uk/"
      />

      <Container id="top-nav">
        <AppBar menuOpen={menuIsOpen}>
          <Toolbar>
            <Link href={basePath || '/'}>
              <Image src={logo} alt="RDA" />
            </Link>

            <RightCol>
              <Menu onClick={handleOpenBurgerMenu} id="menuBtn">
                <Line first menuIsOpen={menuIsOpen} />
                <Line second menuIsOpen={menuIsOpen} />
                <Line third menuIsOpen={menuIsOpen} />
              </Menu>
            </RightCol>
          </Toolbar>
        </AppBar>
      </Container>

      <Container id="mobile-container-nav" hidden>
        <AppBar menuOpen={menuIsOpen}>
          <Toolbar>
            <Link href={basePath || '/'}>
              <Image src={logo} alt="RDA" />
            </Link>

            <RightCol>
              <Menu onClick={handleOpenBurgerMenu}>
                <Line first menuIsOpen={menuIsOpen} />
                <Line second menuIsOpen={menuIsOpen} />
                <Line third menuIsOpen={menuIsOpen} />
              </Menu>
            </RightCol>
          </Toolbar>
        </AppBar>
      </Container>
    </Outer>
  );
};

const Outer = styled.div`
  display: none;

  @media (max-width: 1023px) {
    display: block;
  }
`;

const Container = styled.div<{ hidden?: boolean }>`
  flex-grow: 1;
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  display: none;
  height: 70px;
  z-index: 5555;

  @media (max-width: 1023px) {
    ${props =>
      props.hidden
        ? `position: fixed; top: 0; z-index: 999; box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1);`
        : `display: block;`}
  }
`;

export const Link = styled.a`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none !important;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  height: 28px;

  &:hover,
  &:active,
  &:focus {
    text-decoration: none !important;
  }
`;

export const Image = styled.img`
  width: auto;
  height: 40px;
  cursor: pointer;
`;

export const RightCol = styled.div`
  margin-left: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  z-index: 5;
`;

interface ILine {
  first?: boolean;
  second?: boolean;
  third?: boolean;
  menuIsOpen?: boolean;
}

export const Line = styled.div<ILine>`
  width: 27px;
  height: 2px;
  margin: ${props => props.second && '6px 0'};
  background-color: ${color.brand.blue};
  transform-style: preserve-3d;
  transition: all 200ms ease 0s;
  z-index: 7;
  will-change: transform;
  backface-visibility: hidden;

  ${props =>
    props.second &&
    props.menuIsOpen &&
    'transition: opacity 200ms ease 0s, width 200ms ease 0s; opacity: 0; width: 0px;'}

  transform: ${props =>
    props.first && props.menuIsOpen
      ? 'translateX(0px) translateY(8px) translateZ(0px) rotateX(0deg) rotateY(0deg) rotateZ(45deg)'
      : props.first
      ? 'translateX(0px) translateY(0px) translateZ(0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg)'
      : props.third && props.menuIsOpen
      ? 'translateX(0px) translateY(-8px) translateZ(0px) rotateX(0deg) rotateY(0deg) rotateZ(-45deg)'
      : 'translateX(0px) translateY(0px) translateZ(0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg)'};
`;

interface IAppBar {
  menuOpen?: boolean;
}

export const AppBar = styled.div<IAppBar>`
  box-shadow: none;
  border-bottom: 1px solid ${theme.grey.keyline};
  z-index: 5;
  position: relative;

  ${props => props.menuOpen && 'position: fixed; top: 0; left: 0; right: 0;'}
`;

interface IToolbar {
  transparent?: boolean;
}

export const Toolbar = styled.div<IToolbar>`
  width: 100%;
  background-color: ${props =>
    props.transparent ? 'transparent' : theme.text.white};
  padding: 22px 20px 20px;
  min-height: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default MobileNavigation;
